import AtMentionsViewState from '../store/schema/AtMentionsViewState';
import { DirectorySearchType } from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('shiftAtMentionsHighlight')(function shiftAtMentionsHighlight(
    viewState: AtMentionsViewState,
    isIncrement: boolean
) {
    const findResultCount = viewState.findResultSet.length;
    if (isIncrement) {
        viewState.selectedRecipientIndex++;
    } else {
        viewState.selectedRecipientIndex--;
    }
    // Incrementing on last item loops back to the first item.
    // Decrementing on first item loops back to the last item.
    const totalOptions =
        findResultCount +
        (!!viewState.queryString && viewState.directorySearchType == DirectorySearchType.None
            ? 1
            : 0);
    viewState.selectedRecipientIndex =
        (viewState.selectedRecipientIndex + totalOptions) % totalOptions;
});
